import { httpService } from '~/Services/Service';

// W-0600 — Relatório de Digitalizações (migração ERP uRelDigitalizacao.pas).
// Endpoint read-only: POST /relatorios/digitalizacoes/gerar.
// Body snake_case { data_inicio, data_fim, ordenacao, detalhe }.
// Resposta { linhas: [...], meta: {...} } (httpService.post já devolve o data).
export const gerarRelatorioDigitalizacao = (filtros) =>
  httpService.post('/relatorios/digitalizacoes/gerar', filtros);
